module.exports = __webpack_public_path__ + "static/media/1656587761_12-illustration_png.59b124e5.png";